import React from "react";

const Spinner = () => {
  return (
    <div className="flex-h-center w-full">
      <div className="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
